import { render } from "./options.vue?vue&type=template&id=1c5c17e2"
import script from "./options.vue?vue&type=script&lang=ts"
export * from "./options.vue?vue&type=script&lang=ts"
script.render = render

export default script